"use client";

import {ManageBookingItem} from "@/types/booking";
import {AiOutlineFileSearch} from "react-icons/ai";
import {Card} from "./card";

const cancelledDummyCards: ManageBookingItem[] = [
  {
    name: "Demo User 1",
    image: "/images/avatar.png",
    bookingId: 4001,
    vehicleName: "TN07AB1200",
    bookingTime: new Date("2026-05-26T09:30:00").getTime(),
    driverName: "Raja Driver",
    driverEmpId: "SAMP081",
    pickupPoint: "Gandhipuram",
    dropPoint: "Peelamedu",
    comments: "Booking cancelled by user request"
  },
  {
    name: "Demo User 2",
    image: "/images/avatar.png",
    bookingId: 4002,
    vehicleName: "TN11CD3400",
    bookingTime: new Date("2026-05-26T17:45:00").getTime(),
    driverName: "Mani Driver",
    driverEmpId: "SAMP082",
    pickupPoint: "Ukkadam",
    dropPoint: "Singanallur",
    comments: "Trip cancelled due to route change"
  }
];

export const Cancelled = ({
  filterData
}: {
  filterData: ManageBookingItem[] | null;
}) => {
  const cardsToRender =
    filterData && filterData.length > 0 ? filterData : cancelledDummyCards;

  return (
    <>
      <div className="grid grid-cols-4 gap-3 p-3">
        {cardsToRender.map((b: ManageBookingItem) => (
          <Card key={b.bookingId} b={b} statusType={4} />
        ))}
        {!filterData && (
          <div className="col-span-full flex min-h-[260px] w-full flex-col items-center justify-center text-center">
            {/* Icon */}
            <div className="mb-4">
              <AiOutlineFileSearch size={48} className="" />
            </div>

            {/* Title */}
            <h2 className="text-lg font-semibold text-gray-800">
              No record found
            </h2>

            {/* Description */}
            <p className="mt-1 text-sm text-gray-500">
              Please adjust the name of your search, or there is no data
              available.
            </p>
          </div>
        )}
      </div>
    </>
  );
};
